import { parseLessonContentHash, parseLessonVersionPanelHash } from "./contentEditorNavigation";

/**
 * Expand unit → lesson → version → step to match the lesson editor URL: hash fragments,
 * full-page `/edit-lesson/:id[/version/:versionId]/step/:stepId`, or version panel hash. Mutates `nextExpanded`.
 * Call after optional collapse-of-nested so expansion always wins in the same state update.
 */
export function applyLessonBranchExpansionFromUrl(nextExpanded, {
  lesson,
  unit,
  lessonVersions,
  hashFragment,
  lessonStepEditorRouteMatch,
  lessonAnnotationsRouteMatch,
  lessonStepAnnotationsRouteMatch,
  lessonVersionEditorRouteMatch,
  versionQueryParam,
}) {
  if (!lesson?.id) return;

  const findVersionWithStep = (stepId) =>
    Array.isArray(lessonVersions) && lessonVersions.length
      ? lessonVersions.find((v) =>
          (v.lessonSteps || v.lesson_steps || []).some(
            (s) => s?.id != null && String(s.id) === String(stepId)
          )
        )
      : undefined;

  if (
    lessonVersionEditorRouteMatch &&
    String(lessonVersionEditorRouteMatch.lessonId) === String(lesson.id)
  ) {
    if (unit?.id != null) nextExpanded[`unit-${unit.id}`] = true;
    nextExpanded[`lesson-${lesson.id}`] = true;
    const rawVid = lessonVersionEditorRouteMatch.versionId;
    const vidNum = Number(rawVid);
    if (!Number.isNaN(vidNum)) nextExpanded[`version-${vidNum}`] = true;
    return;
  }

  if (
    lessonAnnotationsRouteMatch &&
    String(lessonAnnotationsRouteMatch.lessonId) === String(lesson.id)
  ) {
    if (unit?.id != null) nextExpanded[`unit-${unit.id}`] = true;
    nextExpanded[`lesson-${lesson.id}`] = true;
    nextExpanded[`ce-ann-lesson-${lesson.id}`] = true;
    const vq = versionQueryParam;
    if (vq != null && vq !== "") {
      const vid = Number(vq);
      if (!Number.isNaN(vid)) nextExpanded[`version-${vid}`] = true;
    }
    return;
  }

  if (
    lessonStepAnnotationsRouteMatch &&
    String(lessonStepAnnotationsRouteMatch.lessonId) === String(lesson.id)
  ) {
    const sid = lessonStepAnnotationsRouteMatch.stepId;
    let versionWithStep = findVersionWithStep(sid);

    if (
      !versionWithStep?.id &&
      Array.isArray(lessonVersions) &&
      lessonVersions.length &&
      versionQueryParam != null &&
      versionQueryParam !== ""
    ) {
      versionWithStep = lessonVersions.find(
        (v) => String(v?.id) === String(versionQueryParam)
      );
    }

    if (unit?.id != null) nextExpanded[`unit-${unit.id}`] = true;
    nextExpanded[`lesson-${lesson.id}`] = true;

    if (versionWithStep?.id != null) {
      nextExpanded[`version-${versionWithStep.id}`] = true;
    } else if (versionQueryParam != null && versionQueryParam !== "") {
      const vidNum = Number(versionQueryParam);
      if (!Number.isNaN(vidNum)) nextExpanded[`version-${vidNum}`] = true;
    }

    nextExpanded[`step-${sid}`] = true;
    nextExpanded[`ce-step-branch-${sid}`] = true;
    nextExpanded[`ce-ann-step-${sid}`] = true;
    return;
  }

  if (!lessonVersions?.length) return;

  const routeMatch = lessonStepEditorRouteMatch;
  const routeStepId =
    routeMatch && String(routeMatch.lessonId) === String(lesson.id)
      ? routeMatch.stepId
      : null;
  const routeVersionId =
    routeMatch &&
    String(routeMatch.lessonId) === String(lesson.id) &&
    routeMatch.versionId != null &&
    routeMatch.versionId !== ""
      ? routeMatch.versionId
      : null;

  const parsedVersion = parseLessonVersionPanelHash(hashFragment ? `#${hashFragment}` : "");
  if (parsedVersion?.versionId != null) {
    if (unit?.id != null) nextExpanded[`unit-${unit.id}`] = true;
    nextExpanded[`lesson-${lesson.id}`] = true;
    nextExpanded[`version-${parsedVersion.versionId}`] = true;
    return;
  }

  const parsed = parseLessonContentHash(hashFragment ? `#${hashFragment}` : "");
  let stepId = null;
  if (parsed?.stepId) {
    stepId = parsed.stepId;
  } else if (routeStepId) {
    stepId = routeStepId;
  }
  if (!stepId) return;

  const versionWithStep =
    routeVersionId != null
      ? lessonVersions.find((v) => String(v?.id) === String(routeVersionId))
      : findVersionWithStep(stepId);
  if (!versionWithStep?.id) return;

  if (unit?.id != null) nextExpanded[`unit-${unit.id}`] = true;
  nextExpanded[`lesson-${lesson.id}`] = true;
  nextExpanded[`version-${versionWithStep.id}`] = true;
  nextExpanded[`step-${stepId}`] = true;
}
